import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { ApiManager } from "services/api";
import { CustomFieldSerializer } from "services/api/custom-fields";
import { IEntityCreateFailure, IEntityDelete } from "store/entities/actions";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { CUSTOM_FIELD, customFieldActions } from "./actions";
import { ICustomField } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const customFieldsResponse = yield call(ApiManager.customFieldsApi.fetchAll);

  if (customFieldsResponse.result) {
    yield put(
      customFieldActions.fetchCollectionSuccess({
        values: CustomFieldSerializer.deserializeList(customFieldsResponse.result),
      })
    );
  } else {
    yield put(customFieldActions.fetchCollectionFailure({ error: customFieldsResponse.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createCustomField(action: IActionWithPayload<string, ICustomField>) {
  const customField = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customFieldsApi.create, customField);

  if (response.result) {
    const createdCustomView = CustomFieldSerializer.deserialize(response.result);
    yield put(customFieldActions.createSuccess({ id: createdCustomView.id, value: createdCustomView }));
  } else {
    const errorObject = response.error.error;
    yield put(customFieldActions.createFailure({ error: errorObject.message, errorObject }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createCustomFieldSuccess() {
  yield call(trackEngagement, "Custom fields: Add custom field", EventPlace.Settings);
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_FIELD_CREATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createCustomFieldFailure(action: IActionWithPayload<string, IEntityCreateFailure>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_FIELD_CREATE_FAILURE, action.payload),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateCustomField(action: IActionWithPayload<string, ICustomField>) {
  const customField = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customFieldsApi.update, customField);
  if (response.result) {
    const updatedCustomField = CustomFieldSerializer.deserialize(response.result);
    if (customField.status === "deactivated") {
      yield call(trackEngagement, "Custom fields: Deactivate custom field", EventPlace.Settings);
      yield put(
        ToastsActions.createToast({
          content: getToastContent(ToastContent.CUSTOM_FIELD_DEACTIVATED_SUCCESS),
          variant: ToastVariant.Success,
        })
      );
    } else if (customField.status === "active") {
      yield call(trackEngagement, "Custom fields: Activate custom field", EventPlace.Settings);
      yield put(
        ToastsActions.createToast({
          content: getToastContent(ToastContent.CUSTOM_FIELD_ACTIVATED_SUCCESS),
          variant: ToastVariant.Success,
        })
      );
    } else {
      yield call(trackEngagement, "Custom fields: Update custom field", EventPlace.Tickets);
      yield put(
        ToastsActions.createToast({
          content: getToastContent(ToastContent.CUSTOM_FIELD_UPDATE_SUCCESS),
          variant: ToastVariant.Success,
        })
      );
    }
    yield put(customFieldActions.updateSuccess({ id: updatedCustomField.id, value: updatedCustomField }));
  } else {
    yield put(customFieldActions.updateFailure({ id: customField.id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* updateCustomFieldFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_FIELD_UPDATE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteCustomField(action: IActionWithPayload<string, IEntityDelete>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.customFieldsApi.deleteTagCustomField, id);

  if (response.result) {
    yield put(customFieldActions.deleteSuccess({ id }));
  } else {
    yield put(customFieldActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteCustomFieldSuccess() {
  yield call(trackEngagement, "Custom fields: Delete custom field", EventPlace.Settings);
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_FIELD_DELETE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteCustomFieldFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.CUSTOM_FIELD_DELETE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* customFieldsSagas() {
  yield all([
    takeLatest(CUSTOM_FIELD.FETCH_COLLECTION.REQUEST, fetchCollection),
    takeEvery(CUSTOM_FIELD.CREATE.REQUEST, createCustomField),
    takeEvery(CUSTOM_FIELD.CREATE.SUCCESS, createCustomFieldSuccess),
    takeEvery(CUSTOM_FIELD.CREATE.FAILURE, createCustomFieldFailure),
    takeEvery(CUSTOM_FIELD.UPDATE.REQUEST, updateCustomField),
    takeEvery(CUSTOM_FIELD.UPDATE.FAILURE, updateCustomFieldFailure),
    takeEvery(CUSTOM_FIELD.DELETE.REQUEST, deleteCustomField),
    takeEvery(CUSTOM_FIELD.DELETE.SUCCESS, deleteCustomFieldSuccess),
    takeEvery(CUSTOM_FIELD.DELETE.FAILURE, deleteCustomFieldFailure),
  ]);
}
